export { default as WeightVariants } from './WeigthVariants';
